import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { LoginService } from 'src/app/core/services/login.service';
import { VerticalSolutionsService } from 'src/app/core/services/verticalsolutions.service';
import { CountryService } from 'src/app/core/services/country.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { VerticalSolution } from 'src/app/model/vertical-solutions';
import { YesNoDialogComponent } from 'src/app/store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { TranslatedVariables } from 'src/app/commons/translated-variables';

@Component({
    selector: 'ms-key-generation',
    templateUrl: './key-generation.component.html',
    styleUrls: ['./key-generation.component.scss'],
})
export class KeyGenerationComponent implements OnInit {
    public cmsObj: CmsObject[];
    public keyGenerationIntroduction: string;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    private vsPrivateKey = ';';
    resellerInfo: VerticalSolution = new VerticalSolution();

    constructor(
        private _formBuilder: FormBuilder,
        private loginService: LoginService,
        public verticalSolutionService: VerticalSolutionsService,
        private countryService: CountryService,
        public dialog: MatDialog,
        public cmsService: CmsService,
        public workFlow: WorkFlowService,
        private variable: TranslatedVariables
    ) {}

    async ngOnInit() {
        await this.getCmsObj();
    }
    async getCmsObj() {
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'keyGeneration');
        this.keyGenerationIntroduction = this.cmsObj.find((x) => x.ContentName == 'keyGeneration.introduction').ContentTranslation;
    }
    async generateSolutionKey() {
        try {
            const dlgAsk = this.dialog.open(YesNoDialogComponent, {
                data: {
                    Title: this.variable.keyGeneration,
                    Message: this.variable.keyGenerationQuestion,
                    Result: true,
                },
            });

            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                if (!resAskDlg) {
                    return;
                } else if (resAskDlg.Result) {
                    this.keyGeneration();
                    this.workFlow.showSnackBar(this.variable.keyGenerationOk);
                }
            });
        } catch (err) {
            alert('Error during generating key');
        }
    }

    async keyGeneration() {
        await this.createKey();
        this.writeContents(this.vsPrivateKey, 'Key' + '.txt', 'text/plain');
    }
    writeContents(content, fileName, contentType) {
        var a = document.createElement('a');
        var file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }
    setResellerInfo() {
        this.resellerInfo.ZucchettiCode = this.verticalSolutionService.currentCodiceAzienda;
        this.resellerInfo.ResellerCountry = this.countryService.resellerCountry;
        this.resellerInfo.ResellerCompanyName = this.verticalSolutionService.resellerCompanyName;
        this.resellerInfo.Signature = '';
        this.resellerInfo.Description = '';
        this.resellerInfo.wsUrl = '';
        this.resellerInfo.Active = false;
        this.resellerInfo.wsNotActive = false;
        this.resellerInfo.IsWSRest = '1';
    }
    async createKey() {
        this.setResellerInfo();
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        let opResult = await this.verticalSolutionService.generateKeys(this.resellerInfo, this.authorizationProperties.accountName);
        this.vsPrivateKey = opResult.Content.toString();
    }
}
